import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="cute-spinner">
        <div className="dot"></div>
        <div className="outline"></div>
      </div>
      <p className="loader-text">Loading...</p>
    </div>
  );
};

export default Loader;